import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardWithSources } from '../../cards/CardWithSources';
import SectionActionButton from '../../buttons/SectionActionButton';
import { GetToKnowMeCardResponseSectionTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataField = ({
  label,
  value
}) => {
  return /*#__PURE__*/_jsxs(View, {
    flex: "1",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-25",
      color: "text-core-subtle",
      children: label
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: value ? 'text-core-default' : 'text-core-disabled',
      children: value || '—'
    })]
  });
};
const GetToKnowMeCard = ({
  section
}) => {
  if (section.__typename !== GetToKnowMeCardResponseSectionTypename) {
    return null;
  }
  const {
    cardTitle,
    businessProfile,
    uniqueValueProposition,
    targetAudience,
    businessModel,
    sourceSections,
    actions
  } = section;
  const fields = [{
    key: 'businessDescription',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "chatspotComponents.sections.getToKnowMeCard.businessDescription"
    }),
    value: businessProfile
  }, {
    key: 'valueProposition',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "chatspotComponents.sections.getToKnowMeCard.valueProposition"
    }),
    value: uniqueValueProposition
  }, {
    key: 'audience',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "chatspotComponents.sections.getToKnowMeCard.audience"
    }),
    value: targetAudience
  }, {
    key: 'businessModel',
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "chatspotComponents.sections.getToKnowMeCard.businessModel"
    }),
    value: businessModel ? I18n.formatList(businessModel) : undefined
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardWithSources, {
      title: cardTitle !== null && cardTitle !== void 0 ? cardTitle : '',
      sourcesSections: sourceSections !== null && sourceSections !== void 0 ? sourceSections : [],
      children: /*#__PURE__*/_jsx(Grid, {
        children: fields.map(({
          key,
          label,
          value
        }) => /*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            md: 6
          },
          children: /*#__PURE__*/_jsx(DataField, {
            label: label,
            value: value
          })
        }, key))
      })
    }), actions && actions.length > 0 && /*#__PURE__*/_jsx(ButtonWrapper, {
      horizontalGap: 4,
      verticalGap: 12,
      children: actions.map((action, index) => /*#__PURE__*/_jsx(SectionActionButton, {
        messageAction: action
      }, index))
    })]
  });
};
export default GetToKnowMeCard;